import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_BASE_URL_WHITELABEL } from '../constants/api'
import { WebhookModel } from '@models'

const webhookRepository = createApi({
	reducerPath: 'webhookRepository',
	baseQuery: fetchBaseQuery({
		baseUrl: API_BASE_URL_WHITELABEL,
	}),
	tagTypes: ['WebhookCompany'],
	endpoints: (builder) => ({
		getByUrl: builder.query<WebhookModel.CompanyShow, { url: string }>({
			queryFn: async ({ url }) => {
				if (!API_BASE_URL_WHITELABEL) {
					return {
						error: {
							status: 'CUSTOM_ERROR',
							error: 'API_BASE_URL_WHITELABEL not defined',
						},
					}
				}

				try {
					const response = await fetch(
						`${API_BASE_URL_WHITELABEL}/v1/webhook/company/${url}`,
						{
							method: 'POST',
						}
					)
					if (!response.ok) {
						throw new Error('Request failed')
					}
					const data = await response.json()
					return { data }
				} catch (error) {
					return { error: { status: 'FETCH_ERROR', error: String(error) } }
				}
			},
			providesTags: ['WebhookCompany'],
		}),
	}),
})

export default webhookRepository
